export default __webpack_public_path__ + "static/media/23_tag_clothes-dryer.358b1bfa.svg";